/* DiagnosTech Theme - Minimal JS */
(function() {
  'use strict';

  // === Produkt-Tabs ===
  document.addEventListener('click', function(e) {
    var tabBtn = e.target.closest('.tabs-nav__item');
    if (tabBtn) {
      var target = tabBtn.dataset.tab;
      var container = tabBtn.closest('.product__tabs');
      if (!container) return;
      container.querySelectorAll('.tabs-nav__item').forEach(function(b) { b.classList.remove('is-active'); });
      container.querySelectorAll('.tab-pane').forEach(function(p) { p.classList.remove('is-active'); });
      tabBtn.classList.add('is-active');
      var pane = container.querySelector('[data-pane="' + target + '"]');
      if (pane) pane.classList.add('is-active');
    }
  });

  // === Mengensteuerung ===
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-action]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type=number]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 9999;
    if (btn.dataset.qtyAction === 'increase' && current < max) input.value = current + 1;
    if (btn.dataset.qtyAction === 'decrease' && current > min) input.value = current - 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // === Produktbild-Galerie ===
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.product__thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.product__gallery');
    if (!gallery) return;
    var src = thumb.querySelector('img').getAttribute('src');
    var mainImg = gallery.querySelector('.product__main-image img');
    if (mainImg && src) {
      mainImg.src = src.replace(/_\d+x\d+/, '_800x800');
    }
    gallery.querySelectorAll('.product__thumb').forEach(function(t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  // === Variant-Auswahl (visuell) ===
  document.addEventListener('click', function(e) {
    var opt = e.target.closest('.variant-option');
    if (!opt) return;
    e.preventDefault();
    var group = opt.parentElement;
    group.querySelectorAll('.variant-option').forEach(function(o) { o.classList.remove('is-selected'); });
    opt.classList.add('is-selected');
    var input = document.querySelector('input[name="id"]');
    if (input && opt.dataset.variantId) input.value = opt.dataset.variantId;
  });
})();
